import { createTheme } from '@mui/material/styles';
import { makeComponents } from './components.js';
import { palette } from './tokens/palette.js';
export { palette } from './tokens/palette.js';
import { typography } from './tokens/typography.js';

const theme = {
  light: createTheme({
    typography,
    palette
  })
};
theme.light.components = makeComponents(theme.light);

export { theme };
